export default __webpack_public_path__ + "static/media/extension_giftcard_gold_w1.6498ff19.svg";